import React, { useEffect } from 'react';
import axios from 'axios';
import './Promo.css'; // or ./Promo.css if you prefer

const Promo = () => {
  const redirectUrl = 'http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3Ddw%3D%3D';

  useEffect(() => {
    // Optional: only trigger on specific path
    if (window.location.pathname === '/promo') {
      const callCallbackAndRedirect = async () => {
        try {
          await axios.get('/getheaders?source=promo');
          window.location.href = redirectUrl;
        } catch (error) {
          console.error('ERROR:', error);
        }
      };

      callCallbackAndRedirect();
    } else {
      // If you always want redirect regardless of path, just call directly:
      // window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <div className="promo-container">
      <div className="promo-loader"></div>
    </div>
  );
};

export default Promo;
